// ...existing code...
import { Box, Button, Group, Select, TextInput, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { repositoryWeb } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { apiPOS } from "../../../library/axios";
import { MessageResponse } from "../../../model/MessageResponse";
import { CustomerImageModel } from "./ImageContentKH";

type FormValues = {
    itemCode: string;
    branchCode: string;
    branchName: string;
    urls: string; // danh sách url, phân tách bằng dấu phẩy
};

type Props = {
    data: CustomerImageModel;

};

const EditImageContentKh = ({ data }: Props) => {
    const [dataBrand, setDataBrand] = useState<any[]>([]);
    const form = useForm<FormValues>({
        initialValues: {
            itemCode: (data as any)?.itemCode ?? "",
            branchCode: (data as any)?.branchCode ?? "",
            branchName: (data as any)?.branchName ?? "",
            urls: (data as any)?.urls ?? "",
        },

        validate: {
            itemCode: (v) => (v.trim().length === 0 ? "Yêu cầu nhập itemCode" : null),
            branchCode: (v) =>
                v.trim().length === 0 ? "Yêu cầu nhập branchCode" : null,
            branchName: (v) =>
                v.trim().length === 0 ? "Yêu cầu nhập branchName" : null,
            urls: (v) => (v.trim().length === 0 ? "Yêu cầu nhập urls" : null),
        },
    });

    const handleSubmit = async (values: FormValues) => {
        try {
            // merge data + values rồi loại bỏ activeText nếu tồn tại
            const merged = { ...data, ...values };
            const { activeText, ...dataResult } = merged;

            const response = await repositoryWeb.post("/CustomerImages/edit", dataResult);
            if (response && response.success) {
                NotificationExtension.Success("Chỉnh sửa hình ảnh khách hàng thành công");
                modals.closeAll();
            }
            else {
                NotificationExtension.Fails("Chỉnh sửa hình ảnh khách hàng thất bại");
            }
        } catch (error) {
            console.log("error", error);
        }
    };
    useEffect(() => {
        // Lấy dữ liệu chi nhánh
        const getBrand = async () => {
            try {
                const url = `/api-pos/api/v1/TblDmInventory/get-select-branch?auth=false`;
                const res = await apiPOS.get<MessageResponse<SelectListItemBase[]>>(
                    url
                );
                console.log("resssss", res);
                if (res && res?.data.success && res.data) {
                    const result = res.data.data.filter((item) => item.att2 != null);
                    setDataBrand(result);
                }
            } catch (err) {
                console.error("Failed to fetch branch data:", err);
            }
        };
        getBrand();
    }, []);
    return (
        <Box w={700}>
            <form onSubmit={form.onSubmit(handleSubmit)}>
                <TextInput
                    label="Item Code"
                    required
                    {...form.getInputProps("itemCode")}
                />

                {/* <TextInput
                    label="Branch Code"
                    mt="sm"
                    required
                    disabled
                    {...form.getInputProps("branchCode")}
                    readOnly
                /> */}

                {/* <TextInput
                    label="Branch Name"
                    mt="sm"
                    required
                    disabled
                    {...form.getInputProps("branchName")}
                /> */}
                <Select
                    size="md"
                    mt="sm"
                    required
                    label="Chi nhánh"
                    searchable
                    clearable
                    placeholder="Chi nhánh"
                    data={
                        Array.isArray(dataBrand)
                            ? dataBrand
                                .filter((branch) => branch.attr6 === "HACOM")
                                .map((item) => ({
                                    value: item.att2,
                                    label: item.addressNew ? item.addressNew : item.att1,
                                }))
                            : []
                    }
                    key={form.key("branchCode")}
                    {...form.getInputProps("branchCode")}
                    onChange={async (value) => {
                        form.setFieldValue(
                            "branchCode",
                            value ? value : ""
                        );
                        const selectedBranch = dataBrand.find((branch) => branch.att2 === value);
                        form.setFieldValue(
                            "branchName",
                            selectedBranch ? selectedBranch.addressNew ? selectedBranch.addressNew : selectedBranch.att1 : ""
                        );
                    }}
                />
                <Textarea
                    label="URLs (phân tách bằng dấu phẩy)"
                    mt="sm"
                    autosize={true}     // cho phép autosize
                    minRows={8}         // số dòng tối thiểu (tăng để có chiều cao lớn)
                    {...form.getInputProps("urls")}
                    placeholder="Nhập danh sách URL, phân tách bằng dấu phẩy (,) nếu có nhiều URL"
                />
                <Group mt="md" justify="flex-end">
                    <Button variant="default" mr={5} onClick={() => modals.closeAll()}>Hủy</Button>
                    <Button type="submit">Lưu</Button>
                </Group>
            </form>
        </Box>
    );
};

export default EditImageContentKh;